// LinkedIn module
var service = require('./../QuizService');

module.exports = {
    template: require('./template.html'),
    replace: false,
    data: function () {
        return {

        }
    },
    ready: function () {

        IN.User.authorize(function () {
            IN.API.Profile("me")
                .fields(["siteStandardProfileRequest"])
                .result(function(result) {
                    service.linkedInUrl = result.values[0].siteStandardProfileRequest.url;

                    window.location = "/#!/form";
                });
        }, this);
    }
}
